import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';

import { createVuetify } from 'vuetify';
import 'vuetify/styles';

export default createVuetify({
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#0dd36b',     // 메인 색상
    gray50: '#f1f1f1',   // 서브 색상
    gray100: '#d3d3d3',
    gray200: '#bdbdbd',
    gray300: '#9f9f9f',
    gray400: '#8d8d8d',
    gray500: '#707070',
    gray600: '#666666',
    gray700: '#505050',
    gray800: '#3e3e3e',
    gray900: '#2f2f2f'
        },
      },
    },
  },
});

const app = createApp(App);

app.use(router);
app.use(vuetify);

app.mount('#app');